import React from 'react';
import { Button, ButtonVariants } from '../../Atoms/Button';

export interface SUCCEESS_MODAL_PROPS {
  title: string;
  desc: string;
  icon: string;
  buttonText?: string;
  buttonFn?: () => void;
}
export const SuccessModal = ({
  title,
  desc,
  icon,
  buttonText,
  buttonFn,
}: SUCCEESS_MODAL_PROPS): JSX.Element => {
  return (
    <div className="flex-col items-center justify-center mx-auto gap-4 px-6">
      {!!icon && (
        <img
          src={icon}
          alt=""
          width={120}
          height={120}
          className="mx-auto sm:w-20 sm:h-20"
        />
      )}

      <div className="py-6">
        <p className="text-grey-900 font-bold text-s-22 sm:text-s-18">
          {title}
        </p>
        <p className="text-grey-700 font-medium text-base py-2 sm:text-s-14">
          {desc}
        </p>
      </div>

      {!!buttonText && (
        <Button
          className="w-full sm:text-base mt-2"
          variant={ButtonVariants.bluefilled}
          rounded="sm"
          onClick={buttonFn}
        >
          {buttonText}
        </Button>
      )}
    </div>
  );
};
